module.exports = __webpack_public_path__ + "img/v4.f7fa0ed9.png";